export default __webpack_public_path__ + "static/media/novena.2b91711c.jpg";